import { newHttpService } from "./new-http-service"

const MASTER_SCOPE = 'auditech'

export async function resolveMasterCompanyId(scopeName: string, currentId: number): Promise<number> {
    if (scopeName === MASTER_SCOPE) return currentId

    const res = await newHttpService.graphql(MASTER_SCOPE, {
        query: `query ($name: String!) { companies(name: $name) { id } }`,
        variables: { name: scopeName },
    })
    const id = res?.companies?.[0]?.id
    if (!id) throw new Error(`Master company id not found for "${scopeName}"`)
    return id
}
